import axios from "axios";
import store from "@/store/index";
import router from "../router";
import Vue from "vue";
import { v4 as uuidv4 } from "uuid"; // Make sure to import uuid

const toastDuration = 8000;
const baseURL = process.env.VUE_APP_GOAL_BANK_PATH;

const HttpMethods = Object.freeze({
  GET: "get",
  POST: "post",
  DELETE: "delete",
  PUT: "put",
	PATCH: 'patch',

});

const visibleMessages = new Set();
function showToast(message, type, duration) {
  if (!visibleMessages.has(message)) {
    visibleMessages.add(message);

    Vue.$toast.open({
      message: message,
      type: type,
      duration: duration,
      position: "top",
    });

    setTimeout(() => {
      visibleMessages.delete(message);
    }, toastDuration);
  }
}

function clearLocalData() {
  localStorage.removeItem("cp_pwa");
  store.commit("userConfig/clearAllConfigs");
}

function handleError({ status, data }) {
  switch (status) {
    case 401:
      // use refresh token for renewing the access token
      break;
    case 403:
      clearLocalData();
      router.push({ name: "login" });
      break;
  }

  showToast(data.detail, "default", toastDuration);
}

async function apiRequest({
  method,
  url,
  service,
  headers,
  data,
  queryString,
  isAuthorized,
  deviceId, // Add deviceId parameter
}) {
  const apiUrl = baseURL + "/" + service + url;

  const token = store.state.userConfig.accessToken;
  const refreshToken = store.state.userConfig.refreshToken;

  // Add custom headers
  headers = {
    ...headers,
    "DEVICE-CLIENT-USER": deviceId,
    "CLIENT-USER-REFERER": store.state.userConfig.refValue,
    ...(token && isAuthorized && { Authorization: token }),
  };

  try {
    switch (method) {
      case HttpMethods.GET:
        return await axios.get(apiUrl + queryString, {
          headers: headers,
        });
      case HttpMethods.POST:
        return await axios.post(apiUrl, data, {
          headers: headers,
        });
      case HttpMethods.DELETE:
        return await axios.delete(apiUrl, {
          headers: headers,
        });
      case HttpMethods.PUT:
        return await axios.put(apiUrl, data, {
          headers: headers,
        });
        case HttpMethods.PATCH:
				return await axios.patch(apiUrl, data, {
					headers: headers,
				});
      default:
        throw new Error("Unsupported HTTP method");
    }
  } catch (error) {
    handleError(error.response);
    return await error.response;
  }
}

// Add deviceId handling here
const apiService = {
  deviceId: null, // Initialize deviceId

  constructor() {
    this.deviceId = this.getDeviceId();
  },

  getDeviceId() {
    let deviceId = store.state.userConfig.deviceIds;
    if (!deviceId) {
      deviceId = uuidv4();
      store.commit("userConfig/setdeviceIds", deviceId);
    }
    return deviceId;
  },

  error_code: null,
  get: async function (url, service = "", headers = {}, queryString = "", isAuthorized = true) {
    return await apiRequest({
      method: HttpMethods.GET,
      url: url,
      service: service,
      headers: headers,
      queryString: queryString,
      isAuthorized: isAuthorized,
      deviceId: this.deviceId, // Use this.deviceId
    });
  },
  post: async function (url, service = "", data, headers = {}, isAuthorized = true) {
    return await apiRequest({
      method: HttpMethods.POST,
      url: url,
      service: service,
      headers: headers,
      data: data,
      isAuthorized: isAuthorized,
      deviceId: this.deviceId, // Use this.deviceId
    });
  },
  delete: async function (url, service = "", headers = {}, isAuthorized = true) {
    return await apiRequest({
      method: HttpMethods.DELETE,
      url: url,
      service: service,
      headers: headers,
      isAuthorized: isAuthorized,
      deviceId: this.deviceId, // Use this.deviceId
    });
  },
  put: async function (url, service = "", headers = {}, isAuthorized = true) {
    return await apiRequest({
      method: HttpMethods.PUT,
      url: url,
      service: service,
      headers: headers,
      data: data,
      isAuthorized: isAuthorized,
      deviceId: this.deviceId, // Use this.deviceId
    });
  },
  patch: async (url, service = '', data, headers = {}, isAuthorized = true) => {
		return await apiRequest({
			method: HttpMethods.PATCH,
			url: url,
			service: service,
			headers: headers,
			data: data,
			isAuthorized: isAuthorized,
		});
	},
};

// Call the constructor to initialize deviceId
apiService.constructor();

export default apiService;
